import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { SagaWorker_GetUserNotes } from 'redux/sagas'
import { Actions_UserNotes } from 'redux/modules/userNotes/Actions'

const { remove } = RequestMethods()

export interface ISagaWorker_DeleteUserNote {
  id: number
  userId: number
}

export default function* SagaWorker_DeleteUserNote(action: PayloadAction<ISagaWorker_DeleteUserNote>) {
  try {
    yield put(Actions_UserNotes.store.showLoader())

    const { id } = action.payload

    yield call(async () => await remove(`/notes/${id}`))

    yield call(SagaWorker_GetUserNotes, action)

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'The note has been successfully deleted',
        type: 'Success',
      }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_UserNotes.store.hideLoader())
  }
}
